import React, {useEffect} from 'react';
import {matchPath, useNavigate, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import {setPendingRedirectPath} from "../../../redux/actions/actionsUser";
import {getCampaignId} from "../../../redux/api/api";
import {ProgressBar} from "primereact/progressbar";
import CompaniesListDetails from "../CompaniesList/CompaniesListDetails";
import {Button} from "primereact/button";
import {menuConfig} from "../../../redux/config";
import CompaniesListDialog from "../Dialog";
const DialerDetailsWindow = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    // @ts-ignore
    const activeClick = useAppSelector(state => state.UsersListReducer.activeClick);
    const companiesData = useAppSelector(state => state.CompaniesListReducer.companiesData)
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as any;
    const detailsLoading = useAppSelector(state => state.CompaniesListReducer.detailsLoading);
    const dialerPermissions = checkPermissions(rolesVision, 'Campaigns');

    useEffect(() => {
        const cleanPath = activeClick?.from?.replace(/^#/, '');

        const match = matchPath("/campaign_details/:id", cleanPath || "");
        if (match) {
            const id = match.params.id;
            dispatch(getCampaignId(id, jwtToken?.jwtToken));
            dispatch(setPendingRedirectPath(null));
        }
    }, [activeClick]);

    useEffect(() => {
        dispatch(setPendingRedirectPath(null));
    }, []);

    useEffect(() => {
        if (!id || isNaN(Number(id))) {
            console.log(7777)
            return;
        } else {
            console.log(4567890)
            dispatch(getCampaignId(id, jwtToken?.jwtToken));
        }
    }, [id]);

    const navigateToMainPage = () => {
        const filteredMenuConfigWithRole = menuConfig.filter((item) =>
            rolesVision.hasOwnProperty(item.name)
        );
        if (filteredMenuConfigWithRole.length) {
            const order = rolesVision ? Object.keys(rolesVision) : [];

            filteredMenuConfigWithRole?.sort((a, b) => {
                const indexA = order?.indexOf(a.name);
                const indexB = order?.indexOf(b.name);
                return indexA - indexB;
            });

            if (filteredMenuConfigWithRole[0].name.toLowerCase() === 'dialer') {
                navigate(`/`);
                window.location.reload();
            } else {
                navigate(`/${filteredMenuConfigWithRole[0].name.toLowerCase()}`);
                window.location.reload();
            }
        }
    }

    return (

        dialerPermissions ? (
            <div className="card">
                {detailsLoading ? (
                    <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
                ) : companiesData?.campaign?.campaignId ? (
                    <>
                    <CompaniesListDetails isWindow={true} />
                    <CompaniesListDialog isWindow={true}/>
                    </>
                ) : (
                    <div className="flex justify-content-center flex-wrap">
                        <div>
                            <h5 className="block flex align-items-center m-0 font-medium">
                                <i className="pi pi-info-circle mr-4" style={{ color: 'red', fontSize: '2.5rem' }}></i>
                                Деталі не знайдені. Перевірте посилання або спробуйте ще раз
                            </h5>
                        </div>
                        <div className="flex justify-content-center w-full mt-3">
                            <Button label="Головна сторінка" onClick={navigateToMainPage} />
                        </div>
                    </div>
                )}
            </div>
        ) : (
            <div className="card">
                <div className="flex justify-content-center flex-wrap">
                    <div>
                        <h5 className="block flex align-items-center m-0 font-medium">
                            <i className="pi pi-info-circle mr-4" style={{ color: 'red', fontSize: '2.5rem' }}></i>
                            Заборонено для вашої ролі.
                        </h5>
                    </div>
                    <div className="flex justify-content-center w-full mt-3">
                        <Button label="Головна сторінка" onClick={navigateToMainPage} />
                    </div>
                </div>
            </div>
        )
    );
};

export default DialerDetailsWindow;
